// Golf BPM Landing Page
// Reads ?tempo= from the URL (set by the quiz), personalizes the page,
// and manages two dual-track audio players (voice / no-voice switching).
//
// Amplitude is initialized here (not inline in the template) to avoid
// Shopify's editor flagging inline script blocks.

if (window.amplitude) {
  window.amplitude.init('db54847d026fb573c8cf8af97b82a12b', {
    fetchRemoteConfig: true,
    autocapture: {
      attribution:         true,
      pageViews:           true,
      sessions:            true,
      formInteractions:    true,
      elementInteractions: true
    }
  });
}

(function () {
  'use strict';

  // ===========================================================================
  // ANALYTICS
  // ===========================================================================

  function trackLandingEvent(eventName, properties) {
    properties = properties || {};
    if (window.amplitude && typeof window.amplitude.track === 'function') {
      window.amplitude.track(eventName, properties);
    }
    console.log('Landing Event:', eventName, properties);
  }

  /** Flush Amplitude before a hard navigation so events aren't dropped. */
  function flushAmplitudeThen(callback, timeoutMs) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      callback();
    }

    setTimeout(finish, timeoutMs || 2000);

    if (window.amplitude && typeof window.amplitude.flush === 'function') {
      try {
        var result = window.amplitude.flush();
        if (result && typeof result.then === 'function') {
          result.then(finish).catch(finish);
          return;
        }
      } catch (e) {
        console.warn('Amplitude flush failed:', e);
      }
    }

    setTimeout(finish, 300);
  }

  function getPlanProps(card) {
    if (!card) return {};
    var nameEl  = card.querySelector('.pricing-name');
    var priceEl = card.querySelector('.pricing-price');
    var pkg     = card.getAttribute('data-plan-pkg') || '';
    return {
      plan_name:    nameEl  ? nameEl.textContent.trim() : null,
      plan_package: pkg ? decodeURIComponent(pkg) : null,
      plan_price:   priceEl ? priceEl.textContent.replace(/\s+/g, '') : null,
      tempo:        TEMPO
    };
  }

  // ===========================================================================
  // TEMPO DETECTION
  // ===========================================================================

  var params = new URLSearchParams(window.location.search);
  var rawTempo = parseInt(params.get('tempo'), 10);

  // Fall back to localStorage if no URL param (e.g. direct visits)
  if (!rawTempo) {
    try {
      var stored = JSON.parse(localStorage.getItem('onboardingData') || '{}');
      rawTempo = stored.fullSwingTempo || 144;
    } catch (e) {
      rawTempo = 144;
    }
  }

  // Only two valid tempos: 144 or 156
  var TEMPO = rawTempo >= 150 ? 156 : 144;

  // ===========================================================================
  // AUDIO PLAYER STATE
  // ===========================================================================

  // Each player tracks two Audio objects (voice version and clean version),
  // whether it is currently playing, and which track is active.
  var players = {};

  function buildPlayer(voiceUrl, cleanUrl) {
    var voiceAudio = new Audio(voiceUrl);
    var cleanAudio = new Audio(cleanUrl);
    voiceAudio.loop = true;
    cleanAudio.loop = true;

    return {
      voiceAudio: voiceAudio,
      cleanAudio: cleanAudio,
      isPlaying: false,
      isVoice: true,
      active: function () {
        return this.isVoice ? this.voiceAudio : this.cleanAudio;
      }
    };
  }

  var AUDIO_BASE = 'https://storage.googleapis.com/golf-bpm.appspot.com/media/music/breaking80/impactZone/';

  // Available full-swing speeds (BPM). Putting is always 135.
  var FULL_SWING_SPEEDS = [126, 144, 156, 184];

  function fullSwingUrls(bpm) {
    return {
      voice: AUDIO_BASE + 'impactZone' + bpm + '-Full-Voice.mp3',
      clean: AUDIO_BASE + 'impactZone' + bpm + '-Full.mp3'
    };
  }

  function puttingUrls(bpm) {
    return {
      voice: AUDIO_BASE + 'impactZone' + bpm + '-Short-Voice.mp3',
      clean: AUDIO_BASE + 'impactZone' + bpm + '-Short.mp3'
    };
  }

  // Tracks the BPM currently loaded in each player
  var currentFullSwingBpm = TEMPO;
  var currentPuttingBpm   = 135;

  function initPlayers() {
    var fullUrls   = fullSwingUrls(TEMPO);
    var puttUrls   = puttingUrls(135);
    players.fullswing = buildPlayer(fullUrls.voice, fullUrls.clean);
    players.putting   = buildPlayer(puttUrls.voice, puttUrls.clean);
  }

  // ===========================================================================
  // SPEED SELECTOR
  // Swaps the full-swing player's audio files to a different BPM.
  // Preserves play/pause state; always restarts from the beginning since
  // different BPM tracks have different lengths and musical phrases.
  // ===========================================================================

  window.selectSpeed = function (bpm) {
    if (bpm === currentFullSwingBpm) return;

    var player     = players.fullswing;
    var wasPlaying = player && player.isPlaying;

    if (player) {
      safePause(player.voiceAudio);
      safePause(player.cleanAudio);
    }

    var urls = fullSwingUrls(bpm);
    players.fullswing = buildPlayer(urls.voice, urls.clean);

    if (wasPlaying) {
      safePlay(players.fullswing.active());
      players.fullswing.isPlaying = true;
    }

    currentFullSwingBpm = bpm;

    // Update BPM labels (section + hero)
    var label = document.getElementById('fullswing-bpm-label');
    if (label) label.textContent = bpm + ' BPM';

    var heroLabel = document.getElementById('hero-bpm-label');
    if (heroLabel) heroLabel.textContent = bpm + ' BPM';

    // Update play button state (carry over playing state)
    updatePlayUI('fullswing', players.fullswing.isPlaying);

    // Highlight the selected speed button in both selectors
    ['#fullswing-speeds', '#hero-speeds'].forEach(function (sel) {
      document.querySelectorAll(sel + ' .speed-btn').forEach(function (btn) {
        var btnBpm = parseInt(btn.getAttribute('data-bpm'), 10);
        btn.classList.toggle('active', btnBpm === bpm);
      });
    });

    resetScrollTimer();
  };

  window.selectPuttingSpeed = function (bpm) {
    if (bpm === currentPuttingBpm) return;

    var player     = players.putting;
    var wasPlaying = player && player.isPlaying;

    if (player) {
      safePause(player.voiceAudio);
      safePause(player.cleanAudio);
    }

    var urls = puttingUrls(bpm);
    players.putting = buildPlayer(urls.voice, urls.clean);

    if (wasPlaying) {
      safePlay(players.putting.active());
      players.putting.isPlaying = true;
    }

    currentPuttingBpm = bpm;

    var label = document.getElementById('putting-bpm-label');
    if (label) label.textContent = bpm + ' BPM';

    updatePlayUI('putting', players.putting.isPlaying);

    document.querySelectorAll('#putting-speeds .speed-btn').forEach(function (btn) {
      var btnBpm = parseInt(btn.getAttribute('data-bpm'), 10);
      btn.classList.toggle('active', btnBpm === bpm);
    });

    resetScrollTimer();
  };

  // ===========================================================================
  // SAFE PLAY HELPER
  // play() returns a Promise. If pause() is called before the Promise resolves
  // the browser throws an AbortError. We always catch it so the console stays
  // clean; any other error is still logged as a warning.
  // ===========================================================================

  function safePlay(audio) {
    var promise = audio.play();
    if (promise !== undefined) {
      promise.catch(function (err) {
        if (err.name !== 'AbortError') {
          console.warn('Audio play error:', err);
        }
      });
    }
  }

  function safePause(audio) {
    audio.pause();
  }

  // ===========================================================================
  // PLAY / PAUSE
  // Pauses the other player automatically so only one plays at a time.
  // ===========================================================================

  window.togglePlay = function (type) {
    var player = players[type];
    if (!player) return;

    if (player.isPlaying) {
      safePause(player.voiceAudio);
      safePause(player.cleanAudio);
      player.isPlaying = false;
    } else {
      // Stop any other playing player
      Object.keys(players).forEach(function (key) {
        if (key !== type && players[key].isPlaying) {
          safePause(players[key].voiceAudio);
          safePause(players[key].cleanAudio);
          players[key].isPlaying = false;
          updatePlayUI(key, false);
        }
      });

      safePlay(player.active());
      player.isPlaying = true;
    }

    updatePlayUI(type, player.isPlaying);
    resetScrollTimer();
  };

  // ===========================================================================
  // VOICE TOGGLE
  // Seamlessly switches between the voice and clean track, preserving
  // the current playback position and play/pause state.
  // ===========================================================================

  window.toggleVoice = function (type) {
    var player = players[type];
    if (!player) return;

    var currentTime = player.active().currentTime;
    var wasPlaying  = player.isPlaying;

    // Pause both tracks before switching
    safePause(player.voiceAudio);
    safePause(player.cleanAudio);

    player.isVoice = !player.isVoice;

    // Sync position to the new track
    player.active().currentTime = currentTime;

    if (wasPlaying) {
      safePlay(player.active());
    }

    updateVoiceUI(type, player.isVoice);
    resetScrollTimer();
  };

  // ===========================================================================
  // UI UPDATES
  // ===========================================================================

  function updatePlayUI(type, isPlaying) {
    var btn  = document.getElementById(type + '-play');
    if (btn) {
      var icon = btn.querySelector('i');
      if (icon) icon.className = isPlaying ? 'fa fa-pause' : 'fa fa-play';
      btn.classList.toggle('playing', isPlaying);
    }

    // Keep hero play button in sync when the fullswing player changes
    if (type === 'fullswing') {
      var heroBtn = document.getElementById('hero-play');
      if (heroBtn) {
        var heroIcon = heroBtn.querySelector('i');
        if (heroIcon) heroIcon.className = isPlaying ? 'fa fa-pause' : 'fa fa-play';
        heroBtn.classList.toggle('playing', isPlaying);
      }
    }
  }

  function updateVoiceUI(type, isVoice) {
    function applyVoiceUI(btn) {
      if (!btn) return;
      btn.classList.toggle('voice-active', isVoice);
      var label = btn.querySelector('.voice-label');
      if (label) label.textContent = isVoice ? 'Mute Voice' : 'Unmute Voice';
      var icon = btn.querySelector('i');
      if (icon) icon.className = isVoice ? 'fa fa-microphone' : 'fa fa-microphone-slash';
    }

    applyVoiceUI(document.getElementById(type + '-voice'));

    // Keep hero voice button in sync when the fullswing player changes
    if (type === 'fullswing') {
      applyVoiceUI(document.getElementById('hero-voice'));
    }
  }

  // ===========================================================================
  // TEMPO COUNTER ANIMATION
  // Counts up from 0 to the target number with an ease-out curve.
  // ===========================================================================

  function animateCounter(el, target, duration, onComplete) {
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease-out cubic
      var eased   = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target;
        if (typeof onComplete === 'function') onComplete();
      }
    }

    requestAnimationFrame(step);
  }

  // ===========================================================================
  // PAGE PERSONALISATION
  // Swaps in the correct tempo value wherever it appears in the DOM.
  // ===========================================================================

  function personalise() {
    // Animated hero counter — reveals player UI on completion
    var heroEl = document.getElementById('hero-tempo');
    if (heroEl) {
      setTimeout(function () {
        animateCounter(heroEl, TEMPO, 1400, function () {
          var wrap = document.getElementById('hero-player-wrap');
          if (wrap) wrap.classList.add('visible');
          startScrollTimer();
        });
      }, 300);
    }

    // Full-swing player label (section + hero)
    var bpmLabel = document.getElementById('fullswing-bpm-label');
    if (bpmLabel) bpmLabel.textContent = TEMPO + ' BPM';

    var heroBpmLabel = document.getElementById('hero-bpm-label');
    if (heroBpmLabel) heroBpmLabel.textContent = TEMPO + ' BPM';

    // Audio section sub-heading
    var audioLabel = document.getElementById('audio-tempo-label');
    if (audioLabel) audioLabel.textContent = TEMPO + ' BPM';

    // Inline tempo references inside pricing cards
    document.querySelectorAll('.tempo-inline').forEach(function (el) {
      el.textContent = TEMPO;
    });

    // Mark the matching speed button as active in both speed selectors
    ['#fullswing-speeds', '#hero-speeds'].forEach(function (sel) {
      document.querySelectorAll(sel + ' .speed-btn').forEach(function (btn) {
        var btnBpm = parseInt(btn.getAttribute('data-bpm'), 10);
        btn.classList.toggle('active', btnBpm === TEMPO);
      });
    });
  }

  // ===========================================================================
  // 30-SECOND AUTO-SCROLL COUNTDOWN
  // Starts after the tempo animation + autoplay reveal.
  // Resets whenever the user interacts with any player control.
  // On reaching 0 it smooth-scrolls to #pricing.
  // ===========================================================================

  var scrollTimer       = null;
  var scrollSecondsLeft = 30;
  var SCROLL_DURATION   = 30;
  var timerStarted      = false;

  function updateCountdownUI(seconds) {
    var secEl  = document.getElementById('countdown-sec');
    var fillEl = document.getElementById('countdown-fill');

    if (secEl)  secEl.textContent = seconds;
    if (fillEl) fillEl.style.width = (seconds / SCROLL_DURATION * 100) + '%';
  }

  function onTimerExpired() {
    // Pause audio
    var player = players.fullswing;
    if (player && player.isPlaying) {
      safePause(player.voiceAudio);
      safePause(player.cleanAudio);
      player.isPlaying = false;
      updatePlayUI('fullswing', false);
    }
    // Scroll to pricing
    var pricingEl = document.getElementById('pricing');
    if (pricingEl) pricingEl.scrollIntoView({ behavior: 'smooth' });
  }

  function startScrollTimer() {
    if (timerStarted) return; // only fire once per page load
    timerStarted = true;

    // Reveal the countdown bar and label
    var cdEl    = document.getElementById('hero-countdown');
    var labelEl = document.querySelector('.hero-countdown-label');
    if (cdEl)    cdEl.classList.add('visible');
    if (labelEl) labelEl.classList.add('visible');

    scrollSecondsLeft = SCROLL_DURATION;
    updateCountdownUI(scrollSecondsLeft);

    scrollTimer = setInterval(function () {
      scrollSecondsLeft--;
      updateCountdownUI(scrollSecondsLeft);

      if (scrollSecondsLeft <= 0) {
        clearInterval(scrollTimer);
        onTimerExpired();
      }
    }, 1000);
  }

  function resetScrollTimer() {
    if (!timerStarted) return; // don't reset if the timer hasn't started yet

    clearInterval(scrollTimer);
    scrollSecondsLeft = SCROLL_DURATION;
    updateCountdownUI(scrollSecondsLeft);

    scrollTimer = setInterval(function () {
      scrollSecondsLeft--;
      updateCountdownUI(scrollSecondsLeft);

      if (scrollSecondsLeft <= 0) {
        clearInterval(scrollTimer);
        onTimerExpired();
      }
    }, 1000);
  }

  // ===========================================================================
  // REVIEWS CAROUSEL
  // ===========================================================================

  var carousel = {
    index:    0,
    total:    0,
    track:    null,
    dots:     null,
    timer:    null,
    interval: 5000
  };

  function initCarousel() {
    carousel.track = document.getElementById('carousel-track');
    carousel.dots  = document.getElementById('carousel-dots');
    if (!carousel.track || !carousel.dots) return;

    var slides = carousel.track.querySelectorAll('.carousel-slide');
    carousel.total = slides.length;

    // Build dot buttons
    for (var i = 0; i < carousel.total; i++) {
      var dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Review ' + (i + 1));
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', function () {
        carouselGoTo(parseInt(this.getAttribute('data-index'), 10));
      });
      carousel.dots.appendChild(dot);
    }

    carouselAutoPlay();
  }

  function carouselGoTo(index) {
    carousel.index = (index + carousel.total) % carousel.total;
    carousel.track.style.transform = 'translateX(-' + (carousel.index * 100) + '%)';

    carousel.dots.querySelectorAll('.carousel-dot').forEach(function (dot, i) {
      dot.classList.toggle('active', i === carousel.index);
    });
  }

  window.carouselMove = function (dir) {
    carouselGoTo(carousel.index + dir);
    // Reset auto-play timer on manual navigation
    clearInterval(carousel.timer);
    carouselAutoPlay();
  };

  window.carouselPause  = function () { clearInterval(carousel.timer); };
  window.carouselResume = function () { carouselAutoPlay(); };

  function carouselAutoPlay() {
    carousel.timer = setInterval(function () {
      carouselGoTo(carousel.index + 1);
    }, carousel.interval);
  }

  // ===========================================================================
  // PLAN SELECTION
  // ===========================================================================

  window.selectPlan = function (card) {
    document.querySelectorAll('.pricing-card').forEach(function (c) {
      c.classList.remove('selected');
    });
    card.classList.add('selected');
    trackLandingEvent('plan_selected', getPlanProps(card));
    resetScrollTimer();
  };

  window.startSelectedPlan = function () {
    var card = document.querySelector('.pricing-card.selected');
    if (!card) return;
    trackLandingEvent('get_started_clicked', getPlanProps(card));
    var url = card.getAttribute('data-plan-url');
    var pkg = card.getAttribute('data-plan-pkg');
    if (url && pkg) handlePurchase(url, pkg);
  };

  // ===========================================================================
  // PURCHASE HANDLER
  // ===========================================================================

  var STORE_QUIZ_DATA_URL = 'https://us-central1-golf-bpm.cloudfunctions.net/storeQuizData';

  window.handlePurchase = function (rcBaseUrl, packageId) {
    var emailEl = document.getElementById('purchase-email');
    var email   = emailEl ? emailEl.value.trim().toLowerCase() : '';

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert('Please enter a valid email address, or leave the field blank to continue.');
      return;
    }

    if (window.fbq) fbq('track', 'InitiateCheckout');
    if (window.ttq) ttq.track('InitiateCheckout');
    if (window.twq) twq('event', 'tw-re5nd-rfcr9', { currency: 'USD' });

    // Collect quiz data from URL params + localStorage
    var urlParams = new URLSearchParams(window.location.search);
    var quizData  = {};
    try { quizData = JSON.parse(localStorage.getItem('onboardingData') || '{}'); } catch (e) {}

    var payload = {
      email:             email || null,
      fullSwingTempo:    TEMPO,
      puttingTempo:      parseInt(urlParams.get('puttingTempo'), 10) || quizData.puttingTempo  || 135,
      primaryGoal:       urlParams.get('goal')        || quizData.primaryGoal       || null,
      primaryFocus:      urlParams.get('focus')       || quizData.primaryFocus      || null,
      focusArea:         urlParams.get('focus')       || quizData.focusArea         || null,
      frustration:       quizData.frustration         || null,
      golferType:        quizData.golferType          || null,
      backswingPosition: quizData.backswingPosition   || null,
      swingTempoType:    quizData.swingTempoType      || null,
      practiceFrequency: quizData.practiceFrequency   || null,
      nineIronDistance:  quizData.nineIronDistance    || null,
      takesLessons:      quizData.takesLessons        || null,
      typicalScore:      quizData.typicalScore        || null,
      handicap:          urlParams.get('handicap')    || quizData.handicap          || null,
      quizVersion:       quizData.version             || '1.0',
      startedAt:         quizData.startedAt           || null,
      rawQuizData:       quizData
    };

    // Show loading state on the single CTA button
    var activeBtn    = document.getElementById('pricing-cta') || document.activeElement;
    var originalText = activeBtn ? activeBtn.textContent : '';
    if (activeBtn) {
      activeBtn.textContent = 'Loading\u2026';
      activeBtn.disabled    = true;
    }

    function redirectToRC(sessionId) {
      var url = rcBaseUrl + encodeURIComponent(sessionId) + '/checkout?package_id=' + packageId;
      flushAmplitudeThen(function () {
        window.location.href = url;
      });
    }

    fetch(STORE_QUIZ_DATA_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.sessionUUID) {
          redirectToRC(data.sessionUUID);
        } else {
          throw new Error('No sessionUUID in response');
        }
      })
      .catch(function (err) {
        console.warn('storeQuizData failed, using fallback redirect:', err);
        if (activeBtn) {
          activeBtn.textContent = originalText;
          activeBtn.disabled    = false;
        }
        // Fallback: redirect directly so the user is never blocked from purchasing
        var fallbackId = 'web_' + TEMPO + '_' + Date.now();
        redirectToRC(fallbackId);
      });
  };

  // ===========================================================================
  // AUTOPLAY WITH INTERACTION FALLBACK
  // Chrome/Safari block audio autoplay without a prior user gesture.
  // We try immediately; if blocked we register a one-shot listener on the
  // first interaction anywhere on the page and play then.
  // ===========================================================================

  function startAudio() {
    var p = players.fullswing && players.fullswing.active();
    if (!p || players.fullswing.isPlaying) return;

    var promise = p.play();
    if (promise !== undefined) {
      promise.then(function () {
        players.fullswing.isPlaying = true;
        updatePlayUI('fullswing', true);
        hideTapHint();
      }).catch(function () {
        // Still blocked — keep waiting for interaction
      });
    } else {
      players.fullswing.isPlaying = true;
      updatePlayUI('fullswing', true);
      hideTapHint();
    }
  }

  function hideTapHint() {
    var hint = document.getElementById('tap-hint');
    if (hint) {
      hint.style.opacity = '0';
      setTimeout(function () { hint.style.display = 'none'; }, 400);
    }
  }

  function attemptAutoplay() {
    var p = players.fullswing && players.fullswing.active();
    if (!p) return;

    var promise = p.play();
    if (promise !== undefined) {
      promise.then(function () {
        players.fullswing.isPlaying = true;
        updatePlayUI('fullswing', true);
      }).catch(function () {
        // Autoplay blocked — show tap hint and wait for first gesture
        showTapHint();
        var events = ['touchstart', 'mousedown', 'keydown'];

        function onFirstInteraction() {
          events.forEach(function (e) {
            document.removeEventListener(e, onFirstInteraction);
          });
          startAudio();
        }

        events.forEach(function (e) {
          document.addEventListener(e, onFirstInteraction, { once: true });
        });
      });
    } else {
      players.fullswing.isPlaying = true;
      updatePlayUI('fullswing', true);
    }
  }

  function showTapHint() {
    var hint = document.getElementById('tap-hint');
    if (hint) {
      hint.style.display = 'flex';
      setTimeout(function () { hint.style.opacity = '1'; }, 10);
    }
  }

  // ===========================================================================
  // INIT
  // ===========================================================================

  document.addEventListener('DOMContentLoaded', function () {
    personalise();
    initPlayers();
    initCarousel();

    // Attempt autoplay immediately.
    // If the browser blocks it (Chrome autoplay policy), fall back to playing
    // on the first user interaction anywhere on the page.
    attemptAutoplay();
  });

}());
